import addCost from './addCost.vue'//服务成本
import addMonthlyIncome from './addMonthlyIncome.vue'//当月收入
import addCommissions from "./addCommissions.vue"//销售佣金
import saleInfoList from "./saleInfoList.vue"//详情列表
import editCommissions from './editCommissions.vue'//服务成本
let a = Object.assign({ addCost, addMonthlyIncome, addCommissions, saleInfoList,editCommissions })
export default a
